module.exports = __webpack_public_path__ + "img/logo-full.60fbcd55.svg";